<template lang="pug">
	.campaigns-list
		.flex-col.header
			.flex-row.justify.wrap
				.campaign-header.flex-row.wrap
					h2.content-block {{$tCaption('Campaigns')}}
					DxButtonGroup(:items="filters", :selected-item-keys="[filter]", key-expr="id",  @item-click="e => filter = e.itemData.id")
					.totals.flex-row
						.flex-col
							span.grey.upper.font-small {{}}$tCaption('Campaigns')}
							span {{formatNumber(campaignsData.TotalNumberOfRecords, '###0')}}
						.flex-col
							span.grey.upper.font-small {{$tCaption('Spots ordered')}}
							span {{formatNumber(campaignsData.TotalOrderedSpots, 'fixedPoint', 0)}}
						.flex-col
							span.grey.upper.font-small {{$tCaption('Impressions ordered')}}
							span {{formatNumber(campaignsData.TotalOrderedImpressions, 'fixedPoint', 0)}}
				.flex-col.list-pager.center
					pager(:count="campaignsData.TotalNumberOfPages", :pageIndex="campaignsData.PageNumber-1", @change="v => currentPageIndex = v")
		.campaign.flex-row.wrap(v-if="!isLoading", v-for="campaign in campaigns", @click="v => openCampaign(campaign)")
			.flex-col.campaign-data
				.flex-col.campaign-name
					.flex-row.font-big {{campaign.Name}}
					.flex-row.grey.upper.font-small {{campaign.BusinessCategory}}
				.flex-row.campaign-info
					.flex-col.block {{$tCaption('Buy')}}
					.flex-col.block
						.flex-row.grey.upper.font-small {{$tCaption('Impressions')}}
						.flex-row {{formatNumber(campaign.TotalTargetImpressions)}}
					.flex-col.block
						.flex-row.grey.upper.font-small {{$tCaption('GRPs')}}
						.flex-row {{formatNumber(campaign.TotalTargetGRP)}}
					.flex-col.block
						.flex-row.grey.upper.font-small {{$tCaption('Budget')}}
						.flex-row ${{formatNumber(campaign.Budget)}}
			.flex-col.flex-1.campaign-spots.justify
				.flex-row.justify
					.flex-col {{formatDate(campaign.StartDate)}}
					.flex-col {{formatDate(campaign.EndDate)}}
				.flex-col
					.flex-row.grey.upper.font-small {{$tCaption('SPOTS AIRED')}} {{campaign.TrafficSpotsAired}}
					.flex-row.flex-1
						.percentage
							.value(v-if="campaign.TrafficSpotsAired", :style="{ width: `${campaign.TrafficSpotsAired * 100 / campaign.TrafficTotalSpots}%` }")
								.indicator {{formatNumber(campaign.TrafficSpotsAired * 100 / campaign.TrafficTotalSpots, '##0.#')}}%
		.loading.flex-row.space(v-if="isLoading")
			.loader
				i.fas.fa-circle-notch.fa-spin
			span {{$tCaption('Loading')}}..
		.flex-col.list-pager.center(v-if="campaignsData && campaignsData.TotalNumberOfRecords > 3")
			pager(:count="campaignsData.TotalNumberOfPages", :pageIndex="campaignsData.PageNumber-1", @change="v => currentPageIndex = v")
</template>

<script>
import Data from 'app-core/Data.js';
import moment from 'moment';
import pager from 'app-core/Pager.vue';
import DxButtonGroup from 'devextreme-vue/button-group';

export default {
		translationCategory: 'dashboard.List',
	data() {
		return {
			campaignsData: {},
			currentPageIndex: 0,
			filter: 0,
			isLoading: true,
			filters: [
                {id: 0, text: () => this.$tCaption('All'), hint: () => this.$tCaption('All')},
                {id: 1, text: () => this.$tCaption('Active'), hint: () => this.$tCaption('Active')},
                {id: 2, text: () => this.$tCaption('Recently completed'), hint: () => this.$tCaption('Recently completed')},
                {id: 3, text: () => this.$tCaption('My campaigns '), hint: () => this.$tCaption('My campaigns ')},
            ],
		};
	},
	computed: {
		campaigns() {
			return this.campaignsData && this.campaignsData.Results || [];
		}
	},
	watch: {
		currentPageIndex() {
			this.loadCampaigns();
		},
		filter() {
			this.loadCampaigns();
		}
	},
	created() {
		this.t = this;
		this.loadCampaigns();
	},
	methods: {
		loadCampaigns() {
			this.isLoading = true;
			Data.getCampaigns(this.filter, this.currentPageIndex + 1).then(r => {
				if (__DEBUG__)
					console.info('Campaigns loaded');
				this.campaignsData = r;
			}).finally(() => {
				this.isLoading = false;
			});
		},
		formatDate(d) {
			return d ? moment(d).format('L') : null;
		},
		formatNumber(a, b, c) {
			if (!b) {
				if (a > 1000) b = this.$tCaption('thousands');
				if (a > 1000000) b = this.$tCaption('millions');
			}
			return Data.formatNumber(a, b || 'fixedPoint', c !== null ? c : 1);
		},
		openCampaign(campaign) {
			if (__DEBUG__)
				console.info('Campaign click', { campaign });
			this.$router.push({ path: `/dashboard/Details/${campaign.QuoteNumber}` });
		}
	},
	components: {
		pager,
		DxButtonGroup
	}
};
</script>
<style lang="scss">
	.campaigns-list {
		@import "main/themes/generated/variables.base.scss";

		.dx-buttongroup {
			margin: 10px;
		}

		.loading {
			padding: 20px;
		}

		.campaign-header {
			align-items: center;

			.dx-button {
				height: 30px;
				font-size: 12px;
			}
		}

		> .header {
			background: #ededed;
		}

		.totals {
			font-size: 30px;
			font-weight: 100;
			padding: 5px 20px 5px 20px;

			> * {
				padding: 10px;
			}
		}

		.list-pager {
			padding: 20px;
		}

		.campaign {
			padding: 5px 20px 10px 20px;
			border-bottom: 1px solid rgba(0,0,0,0.05);
			transition: 0.3s;
			cursor: pointer;

			.campaign-data {
				justify-content: center;

				.campaign-info {
					border-radius: 4px;
					background: rgba(0, 0, 0, 0.02);
					min-width: 20vw;
					justify-content: space-around;

					> .block {
						padding: 10px;
						justify-content: center;
						color: $base-accent;
					}
				}
			}

			.campaign-spots {
				min-width: 400px;
				padding: 20px;

				.percentage {
					width: 100%;
					height: 30px;
					background: rgba(0,0,0,0.02);
					border-radius: 10px;
					position: relative;

					> .value {
						position: absolute;
						height: 100%;
						top: 0px;
						left: 0px;

						> .indicator {
							background: $base-accent;
							width: 100%;
							height: 22px;
							margin: 4px;
							border-radius: 8px;
							text-align: center;
							color: $base-bg;
							vertical-align: middle;
							line-height: 1.9;
							min-width: 35px;
							font-size: 12px;
						}
					}
				}
			}

			&:hover {
				background: $base-accent;
				color: $base-bg;

				.grey {
					color: $base-bg-transparent;
				}

				.block {
					color: $base-bg !important;
				}

				.percentage {
					background: rgba(0,0,0,0.1);
				}
			}
		}
	}
</style>
